// import { motion } from "framer-motion";

// export default function MainVideo() {
//   return (
//     <section className="relative min-h-screen w-full overflow-hidden">
//       {/* Background Video */}
//       <video
//         className="absolute inset-0 h-full w-full object-cover"
//         autoPlay
//         muted
//         loop
//         playsInline
//         preload="auto"
//       >
//         {/* Optional: add webm first */}
//         {/* <source src="/hero.webm" type="video/webm" /> */}
//         <source src="/hero.mp4" type="video/mp4" />
//       </video>

//       {/* Overlay for readability */}
//       <div className="absolute inset-0 bg-[#0F1C24]/70" />
//       <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/50" />

//       {/* Subtle brand glow */}
//       <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full blur-3xl opacity-25 bg-[#F47C20]" />
//       <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full blur-3xl opacity-20 bg-[#E83E6F]" />

//       {/* Content */}
//       <div className="relative z-10 flex min-h-screen items-center">
//         <div className="max-w-7xl mx-auto px-6 md:px-8 w-full">
//           <motion.div
//             initial={{ opacity: 0, y: 18 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7, ease: "easeOut" }}
//             className="max-w-3xl"
//           >
//             {/* Badge / small label */}
//             <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 backdrop-blur">
//               <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
//               <span className="text-xs md:text-sm text-white/80 tracking-wide">
//                 CUSTOM MANUFACTURING SOLUTIONS
//               </span>
//             </div>

//             {/* Heading */}
//             <h1 className="mt-6 text-4xl md:text-6xl font-extrabold leading-tight text-white">
//               ELEVATE YOUR{" "}
//               <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
//                 SUPPLEMENT BRAND
//               </span>
//             </h1>

//             {/* Subtitle */}
//             <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed">
//               India&apos;s No.1 contract manufacturer for dietary supplements –{" "}
//               <span className="text-white font-semibold">Quality</span>,{" "}
//               <span className="text-white font-semibold">Innovation</span>,{" "}
//               <span className="text-white font-semibold">Reliability</span>.
//             </p>

//             {/* Buttons */}
//             <div className="mt-8 flex flex-col sm:flex-row gap-4">
//               <motion.a
//                 whileHover={{ y: -2 }}
//                 whileTap={{ scale: 0.98 }}
//                 href="/contact"
//                 className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm md:text-base font-semibold
//                            bg-gradient-to-r from-[#F47C20] to-[#E83E6F]
//                            text-white shadow-lg shadow-black/25"
//               >
//                 CONTACT US
//               </motion.a>

//               <motion.a
//                 whileHover={{ y: -2 }}
//                 whileTap={{ scale: 0.98 }}
//                 href="/products"
//                 className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm md:text-base font-semibold
//                            border border-white/25 bg-white/5 text-white backdrop-blur
//                            hover:bg-white/10 transition"
//               >
//                 EXPLORE PRODUCTS
//               </motion.a>
//             </div>

//             {/* Optional: small trust line */}
//             <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 text-xs text-white/70">
//               <div className="rounded-lg border border-white/10 bg-white/5 px-3 py-3 backdrop-blur">
//                 Private Label
//               </div>
//               <div className="rounded-lg border border-white/10 bg-white/5 px-3 py-3 backdrop-blur">
//                 Bulk Manufacturing
//               </div>
//               <div className="rounded-lg border border-white/10 bg-white/5 px-3 py-3 backdrop-blur">
//                 Global Export
//               </div>
//               <div className="rounded-lg border border-white/10 bg-white/5 px-3 py-3 backdrop-blur">
//                 Quality Controlled
//               </div>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }


import { motion } from "framer-motion";

export default function MainVideo() {
  return (
    <section className="relative min-h-screen w-full overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src="/hero.mp4" type="video/mp4" />
      </video>

      {/* Elegant overlay */}
      <div className="absolute inset-0 bg-[#0B1620]/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />

      {/* Soft brand glows */}
      <div className="pointer-events-none absolute -top-28 -left-28 h-72 w-72 rounded-full blur-3xl opacity-25 bg-[#F47C20]" />
      <div className="pointer-events-none absolute -bottom-28 -right-28 h-80 w-80 rounded-full blur-3xl opacity-20 bg-[#E83E6F]" />

      {/* Centered Content */}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-6">
        <div className="w-full max-w-4xl text-center">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, ease: "easeOut" }}
            className="mx-auto"
          >
            {/* Top Badge */}
            <div className="mx-auto inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-5 py-2 backdrop-blur">
              <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
              <span className="text-xs md:text-sm text-white/80 tracking-[0.2em] uppercase">
                Custom Manufacturing Solutions
              </span>
            </div>

            {/* Title */}
            <h1 className="mt-7 text-4xl md:text-6xl font-extrabold leading-tight text-white">
              ELEVATE YOUR{" "}
              <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
                SUPPLEMENT BRAND
              </span>
            </h1>

            {/* Subtitle */}
            <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed max-w-3xl mx-auto">
              India&apos;s No.1 contract manufacturer for dietary supplements —{" "}
              <span className="text-white font-semibold">Quality</span>,{" "}
              <span className="text-white font-semibold">Innovation</span>,{" "}
              <span className="text-white font-semibold">Reliability</span>.
            </p>

            {/* Buttons */}
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
              <motion.a
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                href="/contact"
                className="inline-flex items-center justify-center rounded-md px-7 py-3 text-sm md:text-base font-semibold
                           bg-gradient-to-r from-[#F47C20] to-[#E83E6F]
                           text-white shadow-lg shadow-black/30"
              >
                CONTACT US
              </motion.a>

              <motion.a
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                href="/products"
                className="inline-flex items-center justify-center rounded-md px-7 py-3 text-sm md:text-base font-semibold
                           border border-white/25 bg-white/5 text-white backdrop-blur
                           hover:bg-white/10 transition"
              >
                EXPLORE PRODUCTS
              </motion.a>
            </div>

            {/* Elegant Trust Pills */}
            <div className="mt-10 flex flex-wrap items-center justify-center gap-3 text-xs text-white/70">
              {["Private Label", "Bulk Manufacturing", "Export Ready", "Quality Controlled"].map(
                (item) => (
                  <div
                    key={item}
                    className="rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur"
                  >
                    {item}
                  </div>
                )
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}